export default {"src":"/_next/static/media/text.d5d25ae3.svg","height":20,"width":84,"blurWidth":0,"blurHeight":0};